import React, { useEffect } from 'react'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { SandboxState, useSandboxStore } from '@frame/lib/stores/useSandboxStore'

import Fields from './fields'
import { Form } from './form'
import { Search } from './search'

const sandboxScreens = (task: DirectTask) => ({
  [SandboxState.SEARCH]: () => <Search />,
  [SandboxState.FORM]: () => <Form task={task} />,
  [SandboxState.FIELDS]: () => <Fields />,
})

export function SandboxScreen({ task }: { task: DirectTask }) {
  const { state, setState, setCompany } = useSandboxStore(({ state, setState, setCompany }) => ({
    state,
    setState,
    setCompany,
  }))

  useEffect(() => {
    if (task.employer_name) {
      setCompany({
        name: task.employer_name,
        domain: '',
        logo: '',
      })
      setState(SandboxState.FORM)
    }
  }, [task, setCompany, setState])

  return sandboxScreens(task)[state]()
}
